module.exports = __webpack_public_path__ + "static/HIPAA-Privacy-form-2df15465a7830bc5274da5efbee8741d.pdf";